export default "__VITE_ASSET__BPXPp7iB__"